import React from "react";

function User() {
  return (
    <div>
      <h3>User Page</h3>
    </div>
  );
}
export default User;
